var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Виды работ",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "WorkTypeCatalogAdd",
      "route-edit": "WorkTypeCatalogEdit",
      "route-view": "WorkTypeCatalogView",
      "route-path": "/work_type_catalogs",
      "can-edit": _vm.canEditWorkTypeCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-792cf004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792cf004","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkType/WorkTypeCatalogs.vue
// module id = null
// module chunks = 